// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.css
// module id = 232
// module chunks = 0